import React, { useCallback, useMemo, useState } from "react";
import { LANGUAGES, LANGUAGES_MENU } from "../../../i18n/config";
import i18next from "i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeLanguagePop } from "../../../redux/action/member/memberAction";
import { useTranslation } from "react-i18next";
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Text,
  Button,
  useColorModeValue,
  Image,
  filter,
  AbsoluteCenter,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";

import { COMMON_WEB_PATH } from "../../../constant";
import useWebsiteInfo from "../../../hook/useWebsiteInfo";
import useLongMachineSetting from "../../../hook/useLongMachineSetting";

const LanguagePage = () => {
  const { t, i18n } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const textActiveColor = useColorModeValue("white", "white");

  const website_language = window.web_language || [];
  const { getImagePath, images } = useWebsiteInfo();

  // 使用當前語言作為預設選中語言
  const [selectedLanguage, setSelectedLanguage] = useState(i18next.language);

  const memberData = useSelector((state) => state.isMemberInfo);
  const { test } = memberData || {};
  const language_filter = useMemo(() => {
    return LANGUAGES_MENU?.filter((item) => {
      if (test == 1) {
        return item;
      } else {
        return website_language?.includes(item.value);
      }
    });
  }, [test, website_language]);

  const onClose = async () => {
    await dispatch(closeLanguagePop());
  };

  // 處理語言選擇
  const handleLanguageSelect = (langValue) => {
    setSelectedLanguage(langValue);
  };

  // 處理確認按鈕點擊
  const handleConfirmClick = async () => {
    if (selectedLanguage) {
      await i18next.changeLanguage(selectedLanguage);
      localStorage.setItem("i18nextLng", selectedLanguage);
      window.location.assign("/" + selectedLanguage);
    }
  };

  const dispatch = useDispatch();

  const { longMachinePaddingTop } = useLongMachineSetting();

  return (
    <Modal
      onClose={onClose}
      isOpen={true}
      motionPreset="slideInBottom"
      isCentered
      bg="transparent"
    >
      <ModalOverlay bg="rgba(0, 0, 0, 0.6)" />
      <ModalContent
        pt={longMachinePaddingTop}
        display={"flex"}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        bgColor={"transparent"}
      >
        <ModalBody
          w={{
            base: "80%",
            md: "100%",
          }}
          maxW="400px"
          position="relative"
          p="0"
        >
          <Flex direction="column" w="100%">
            {/* 語言選項清單 */}
            <Flex
              flexDirection={"column"}
              alignItems="center"
              justifyContent="center"
              w="100%"
              h="475px"
              bgColor={"transparent"}
              bgImage={`url(${COMMON_WEB_PATH}/911TW/langBG.webp)`}
              bgSize="100% 100%"
              bgRepeat={`no-repeat`}
              pt={"30px"}
              pb="45px"
              px={"5px"}
              position="relative"
            >
              <AbsoluteCenter
                display={"flex"}
                justifyContent={"space-between"}
                w="115%"
              >
                <Image
                  w="20px"
                  alt="left_arrow"
                  src={`${COMMON_WEB_PATH}/911TW/lng_arrow.png`}
                />
                <Image
                  w="20px"
                  alt="left_arrow"
                  transform={"scaleX(-100%)"}
                  src={`${COMMON_WEB_PATH}/911TW/lng_arrow.png`}
                />
              </AbsoluteCenter>
              <Box w="100%" h="100%" overflow="scroll">
                {language_filter?.map((item, index) => {
                  const isSelected = selectedLanguage === item.value;

                  return (
                    <Flex
                      alignItems="center"
                      justifyContent="center"
                      key={`${item.language}-${index}`}
                      bg={
                        isSelected
                          ? `url(${COMMON_WEB_PATH}/911TW/selectLNGbg.webp)`
                          : "transparent"
                      }
                      _hover={{
                        bg: `url(${COMMON_WEB_PATH}/911TW/selectLNGbg.webp)`,
                        bgSize: "100% 100%",
                        bgRepeat: "no-repeat",
                      }}
                      color={isSelected ? "black" : "white"}
                      bgSize="100% 100%"
                      bgRepeat={`no-repeat`}
                      w="100%"
                      h={"65px"}
                      minH="65px"
                      maxH="65px"
                      py="15px"
                      textAlign="center"
                      fontSize="22px"
                      fontWeight="bold"
                      cursor="pointer"
                      borderBottom={
                        index !== language_filter.length - 1
                          ? "1px solid rgba(230, 195, 106, 0.3)"
                          : "none"
                      }
                      onClick={async (event) => {
                        event.stopPropagation();
                        await i18next.changeLanguage(item.value);
                        localStorage.setItem("i18nextLng", item.value);
                        const targetPath = item.value;

                        window.location.assign("/" + targetPath);
                      }}
                    >
                      <Image
                        src={`${COMMON_WEB_PATH}/911TW/lang_${item.value}.webp`}
                        alt={item.text}
                        w={"100%"}
                        maxW={"150px"}
                      />
                    </Flex>
                  );
                })}
              </Box>
            </Flex>

            {/* 確認按鈕 */}
            <Box w="100%" bg="transparent" p="20px" textAlign="center">
              <Box
                as="button"
                bg="transparent"
                onClick={onClose}
                borderRadius="30px"
                _hover={{ opacity: 0.9 }}
                p="0"
              >
                <Image
                  src={images.langYESbtn}
                  alt="確認"
                  w={"100%"}
                  maxW={"150px"}
                />
              </Box>
            </Box>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LanguagePage;
